var isType = require('./isType');

// returns true if x is an instance of type
module.exports = function is(x, type) {
  if (isType(type)) {
    return type.is(x);
  }
  return x instanceof type; // type should be a class constructor
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/is.js
 ** module id = 32
 ** module chunks = 0
 **/